import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isCustomDisplayTextLabelPart } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { Icon } from '../../icon/icon';
import { DisplayTextLink } from './link';
const b = bemClassBuilder('v-display-text-part');
export const DisplayTextPart = observer(({ part, internalActions }) => {
    if (!isCustomDisplayTextLabelPart(part)) {
        return getFormattedText(part);
    }
    if (isLink(part)) {
        return _jsx(DisplayTextLink, { part: part, internalActions: internalActions });
    }
    return getFormattedText(part.text, part.iconName, part.className);
});
DisplayTextPart.displayName = 'DisplayTextPart';
const isLink = (part) => {
    const { href, onClick, internalAction } = part;
    return !!href || !!onClick || !!internalAction;
};
const getFormattedText = (text, iconName, className) => {
    if (!iconName) {
        return _jsx("span", { className: b.block(undefined, className), children: text });
    }
    return (_jsxs("div", { className: b.block(undefined, className), children: [_jsx("span", { className: b.element('text'), children: text }), _jsx(Icon, { className: b.element('icon'), name: iconName })] }));
};
//# sourceMappingURL=part.js.map